import React from 'react';
import {Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, Row} from 'reactstrap';
import BaseComponent from '../BaseComponent';
import PropTypes from 'prop-types';
// import label from '../../message/Label'
import label from 'enqc-utilities/src/label/Label'
import ModalCardHeader from "../Widget/ModalCardHeader";

const { htmlToText } = require('html-to-text');


/*= (message, okCallback, cancelCallback) =>*/
export default class CustomerInfoUnchangeableModal extends BaseComponent{



    render(){
        let {showing, releaseVerification} = this.props
        let inspection = releaseVerification.inspection??{}
        return (
            /*xl-lg-sm*/
            <Modal
                autoFocus={false}
                size="lg"
                centered={true}
                isOpen={showing}
                backdrop={true}
                zIndex="1">
                {super.render()}
                <ModalCardHeader content={label.CustomerInformation}/>
                <ModalBody>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label for="customerOrderNo">{label.CustomerOrderNo}</Label>
                                <Input
                                    type="text"
                                    name="customerOrderNo"
                                    readOnly={true}
                                    value={inspection.customerOrderNo??""}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label for="client">{label.Client}</Label>
                                <Input
                                    type="text"
                                    name="client"
                                    readOnly={true}
                                    value={inspection.client??""}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label for="client">{label.ProductSKU}</Label>
                                <Input
                                    type="text"
                                    name="productSKU"
                                    readOnly={true}
                                    value={inspection.productSKU??""}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label for="client">{label.ProductName}</Label>
                                <Input
                                    type="text"
                                    name="productName"
                                    readOnly={true}
                                    value={inspection.productName??""}/>
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button
                        className="btn-white-normal"
                        onClick={async (e)=>{
                            e.preventDefault()
                            this.props.onClose()
                        }}>
                        {label.Close}
                    </Button>
                </ModalFooter>
            </Modal>
        )
    }
}

CustomerInfoUnchangeableModal.propTypes = {
    releaseVerification:PropTypes.object.isRequired,
    showing:PropTypes.bool.isRequired,
    onClose:PropTypes.func.isRequired,
}
